import tree from "../../../../components/tree.vue";
import MonthTime from "./MonthTime/MonthTime.vue";
import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
    name: "VehicleOrgReport",
    components: {
        tree,
        MonthTime,
        ChangeTime
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            activeName: 'first',
            orgId: '',
        };
    },
    mounted() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        handleClick(event) {
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$nextTick(() => {
                    this.$refs.monthTime.orgId = this.orgId
                    this.$refs.monthTime.getMonthOrderList()
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.changeTime.orgId = this.orgId
                    this.$refs.changeTime.getMonthOrderList()
                })

            }
        },
        initQuery(item) {
            this.orgId = item.id
            if (this.activeName == 'first') {
                this.$refs.monthTime.orgId = this.orgId
                this.$refs.monthTime.getMonthOrderList()
            }
        },
        nodeClick(val) {
            this.orgId = val.label
            if (this.activeName == 'first') {
                this.$refs.monthTime.orgId = val.label
                this.$refs.monthTime.getMonthOrderList()
            } else {
                this.$refs.changeTime.orgId = val.label
                this.$refs.changeTime.getMonthOrderList()
            }
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    },
};
